import React from 'react';
import { UserPlus, BadgePercent, ShieldCheck, Truck, Globe, Phone, Megaphone, Sparkles, ExternalLink } from 'lucide-react';
const benefits = [{
  text: 'Save Up to 25% on ALL Neolife products TODAY when you put any one product on auto-ship! Or get 15% off without the auto-ship every time you order.',
  icon: BadgePercent
}, {
  text: 'No obligations: Buy what you want, When you want',
  icon: ShieldCheck
}, {
  text: 'Possibly lower shipping price',
  icon: Truck
}, {
  text: 'No need to go through a third party and pay retail price. Just log on Neolifeclub.com and place your order',
  icon: Globe
}, {
  text: 'Call Neolife with your ID number and place your order by phone so you get the best price possible',
  icon: Phone
}, {
  text: 'Get information about new products and promotions from Neolife',
  icon: Megaphone
}];
export function JoinPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-419">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-420">
        <div className="max-w-4xl mx-auto text-center" data-id="element-421">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-422">
            <UserPlus className="w-10 h-10 text-[#0e7be1]" data-id="element-423" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-424">
              Join GNLD NeoLife
            </h1>
          </div>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full" data-id="element-425"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-426">
        {/* Hero Headline */}
        <div className="text-center mb-12" data-id="element-427">
          <h2 className="text-2xl md:text-3xl font-bold text-[#e64a19] leading-tight mb-8" data-id="element-428">
            Join GNLD NeoLife just to save up to 25% now & EVERY time you buy!
            <br className="hidden md:block" data-id="element-429" />
            <span className="mt-2 block text-gray-800" data-id="element-430">No obligations.</span>
          </h2>

          {/* Primary CTA */}
          <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#0e7be1] hover:bg-[#0c6bc4] text-white text-lg md:text-xl font-bold px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5" data-id="element-431">
            Click here to join GNLD NeoLife Now!
            <ExternalLink className="w-5 h-5" data-id="element-432" />
          </a>
        </div>

        {/* Welcome Section */}
        <div className="prose prose-lg max-w-none text-gray-600 mb-12" data-id="element-433">
          <p className="text-lg leading-relaxed" data-id="element-434">
            We are excited about your interest in GNLD Neolife! Joining Neolife
            is the first step to a healthier, happier way of life for you and
            your family. There are many great benefits when you join Neolife
            today:
          </p>
        </div>

        {/* Benefits List */}
        <div className="grid gap-6 md:grid-cols-1 mb-8" data-id="element-435">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 p-6 bg-white border border-gray-100 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200" data-id="element-436">
              <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center text-[#0e7be1]" data-id="element-437">
                <benefit.icon className="w-6 h-6" data-id="element-438" />
              </div>
              <div className="flex-grow" data-id="element-439">
                <div className="flex items-center gap-2 mb-1" data-id="element-440">
                  <span className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-441">
                    Benefit {index + 1}
                  </span>
                </div>
                <p className="text-gray-800 font-medium text-lg leading-relaxed" data-id="element-442">
                  {benefit.text}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex items-center gap-2 mb-16 px-6" data-id="element-443">
          <Sparkles className="w-5 h-5 text-[#0e7be1]" data-id="element-444" />
          <p className="text-lg font-semibold text-gray-700" data-id="element-445">And much more!</p>
        </div>

        {/* Bottom CTA */}
        <div className="text-center pt-8 border-t border-gray-100" data-id="element-446">
          <p className="text-xl font-medium text-gray-900 mb-6" data-id="element-447">
            Ready to start your journey?
          </p>
          <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#0e7be1] hover:bg-[#0c6bc4] text-white text-lg md:text-xl font-bold px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5" data-id="element-448">
            Click here to join GNLD NeoLife Now!
            <ExternalLink className="w-5 h-5" data-id="element-449" />
          </a>
        </div>
      </div>
    </div>;
}